import { create } from 'zustand';

const STORAGE_KEY = 'selwyn_saved_events';

const loadIds = () => {
    try {
        return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
    } catch {
        return new Set();
    }
};

const persistIds = (ids) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
    } catch {}
};

export const useSavedEvents = create((set, get) => ({
    savedIds: loadIds(),

    toggle: (id) => {
        const next = new Set(get().savedIds);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        persistIds(next);
        set({ savedIds: next });
    },

    isSaved: (id) => get().savedIds.has(id),

    count: () => get().savedIds.size,
}));
